import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { ERROR_CODE, verifyOtp } from "~/api";
import { ROUTES } from "~/router";
import { useAuthStore, useUserStore } from "~/stores";
import { validateError } from "~/utils";

export const useVerifyOtp = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setHashedUserId = useUserStore((state) => state.setHashedUserId);

  return useMutation({
    mutationFn: verifyOtp,
    onSuccess: (data) => {
      const authStore = useAuthStore.getState();
      authStore.setTokens(data.data.accessToken, data.data.refreshToken);
      authStore.setRedirectTo(data.data.redirectTo ?? null);
      queryClient.invalidateQueries({ queryKey: ["getCurrentUser"] });
    },
    onError: (error: unknown, variables) => {
      const parsedError = validateError(error);
      if (!parsedError) {
        return;
      }

      const { code, hash } = parsedError.response.data.error;

      if (code === ERROR_CODE.pendingEmailVerification && hash) {
        setHashedUserId(hash);
        navigate(ROUTES.pendingVerification, {
          state: { email: variables.email },
        });
      }
    },
  });
};
